import classNames from 'classnames';

import {IconButton} from 'shells/button/icon-button/icon-button';
import {colors} from 'shells/colors/colors';
import {ChevronLeftIcon} from 'shells/icon';
import {CloseHeavyRegularIcon} from 'shells/icon/svg/close-heavy-regular-icon';
import {LeadIcon} from 'shells/icon/svg/lead-icon';
import {LeadRegularPlusIcon} from 'shells/icon/svg/lead-regular-plus-icon';
import {Stack} from 'shells/layout/stack/stack';
import {SectionLabel} from 'shells/typography/section-label';

import styles from './lead-sidebar-header.module.css';

interface Props {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    hasLeads: boolean;
    isLeadCreateAllowed: boolean;
}

export function LeadSidebarHeader(props: Props) {
    const headerClassName = classNames(styles['lead-sidebar-header'], {
        [styles['lead-sidebar-header--collapsed']]: !props.isOpen,
    });

    const canCreateLead = props.isLeadCreateAllowed && !props.hasLeads;

    return (
        <div className={headerClassName}>
            {props.isOpen && (
                <Stack isHorizontal={true} alignItems='center' spacing={8}>
                    <LeadIcon
                        size={20}
                        wrapWithDiv={false}
                        // @ts-expect-error
                        fill={props.hasLeads ? colors.lead : colors.greyLt}
                    />
                    <SectionLabel noBottomBorder={true} noBottomMargin={true}>
                        Lead information
                    </SectionLabel>
                </Stack>
            )}
            <Stack alignItems='center' spacing={24}>
                {!props.isOpen && (
                    <div className='mt-32'>
                        {canCreateLead ? (
                            // @ts-expect-error
                            <LeadRegularPlusIcon size={20} color={colors.greyLt} />
                        ) : (
                            <LeadIcon
                                // @ts-expect-error
                                fill={props.hasLeads ? colors.lead : colors.greyLt}
                                size={20}
                                wrapWithDiv={false}
                            />
                        )}
                    </div>
                )}
                <IconButton
                    size={16}
                    tooltipText={props.isOpen ? 'Collapse' : 'Expand'}
                    icon={props.isOpen ? CloseHeavyRegularIcon : ChevronLeftIcon}
                    onClick={() => props.setIsOpen(!props.isOpen)}
                    noPadding={true}
                />
            </Stack>
        </div>
    );
}
